<template>
  <Teleport to="body">
    <transition name="apperance" :appear="isAppear">
      <div
        v-show="isAppear"
        v-bind="$attrs"
        :class="`${props.modalStyles} ${
          fullheight ? 'modal__fullheight' : ''
        } ${isTopBorder ? 'modal__top-border' : ''}`"
        class="modal"
      >
        <div class="modal-wrapper">
          <div ref="modal" class="modal-container">
            <div
              :class="{ fullheight: props.fullheight }"
              class="modal-content"
            >
              <slot />
            </div>
            <div class="icon-close-wrap" @click="onClose">
              <UiIcon
                name="close"
                :size="smallgrey ? '16' : '24'"
                class="icon-close"
                hover-stroke="#363ef8"
                :stroke="iconColor"
                :class="{
                  white: props.closeWhite,
                  grey: props.closeGrey,
                  smallgrey: props.smallgrey,
                }"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script lang="ts" setup>
import { useScrollLock, onClickOutside, useMagicKeys } from '@vueuse/core';

defineOptions({
  inheritAttrs: false,
});
const props = defineProps({
  modalStyles: {
    type: String,
    default: '',
    validator: (value: string) =>
      !value
        .split(' ')
        .some(
          (str) =>
            str &&
            ![
              'mobile-bottom',
              'lg-bottom',
              'tablet-bottom',
              'desktop-fullscreen',
              'filters-modal',
            ].includes(str)
        ),
  },
  closeWhite: {
    type: Boolean,
    default: false,
  },
  closeGrey: {
    type: Boolean,
    default: false,
  },
  smallgrey: {
    type: Boolean,
    default: false,
  },
  appear: {
    type: Boolean,
    default: true,
  },
  fullheight: {
    type: Boolean,
    default: false,
  },
  noCloseClickOutside: {
    type: Boolean,
    default: false,
  },
  isTopBorder: {
    type: Boolean,
    default: false,
  },
  // не закрывать модалку при клике по определенному классу (сделано, что б не закрывалась модалка
  // при клике на политику яндекс каптчи вне модалки
  ignoreCloseClass: {
    type: String,
    default: '',
  },
});
const html = ref<HTMLElement | null>(null);
const modal = ref<HTMLElement | null>(null);
const isLocked = useScrollLock(html, true);
const emit = defineEmits(['close']);
const isAppear = ref<boolean>(props.appear);
onClickOutside(modal, (e) => {
  const target = e?.target as HTMLElement;
  const isIgnoreClose =
    target &&
    target?.className &&
    props.ignoreCloseClass &&
    target.className.includes(props.ignoreCloseClass);
  if (!props.noCloseClickOutside && !isIgnoreClose) {
    isAppear.value = false;
    setTimeout(() => {
      nextTick(() => emit('close'));
    }, 100);
  }
});
const iconColor = computed(() => {
  if (props.closeWhite) return '#fff';
  if (props.closeGrey) return '#86888f';
  if (props.smallgrey) return '#86888f';
  return '';
});
const onClose = () => {
  isAppear.value = false;
  isLocked.value = false;
  setTimeout(() => {
    nextTick(() => emit('close'));
  }, 100);
};
const { escape } = useMagicKeys();
watch(escape, (v) => {
  if (v) onClose();
});
onMounted(() => {
  html.value = document.querySelector('html');
});

onBeforeUnmount(() => {
  if (html.value) {
    isLocked.value = false;
  }
});
</script>
<style scoped lang="scss" src="./ModalScss.scss" />
